export default __webpack_public_path__ + "4d420c988885e9aa2cd9d5a94faa0b0c.png";